// extracted by mini-css-extract-plugin
export default {"divider":"DataTable_divider__1hWn4","dataRow":"DataTable_dataRow__wI18r","dataValue":"DataTable_dataValue__XELBD","dataTableWrapper":"DataTable_dataTableWrapper__RXlJw"};